import React from 'react';
import ObservationScripting from './ObservationScripting';


const ObservationSelfReflection = () => {
    return <ObservationScripting isSelfReflection={true} />
}

export default ObservationSelfReflection;